import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import baseStyles from './css/BloodPressure.module.css';
import styles from './css/Cholesterol.module.css';
import { Droplet, Send } from 'lucide-react';

const CholesterolTest = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    const [totalCholesterol, setTotalCholesterol] = useState('');
    const [fastingStatus, setFastingStatus] = useState(false);
    const [familyHistory, setFamilyHistory] = useState(false);
    const [clinicalNotes, setClinicalNotes] = useState('');

    useEffect(() => {
        document.body.classList.add(baseStyles.hideSidebar);
        return () => {
            document.body.classList.remove(baseStyles.hideSidebar);
        };
    }, []);

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                cholesterol_test: {
                    totalCholesterol,
                    fastingStatus,
                    familyHistory,
                    clinicalNotes,
                },
            },
        });
    };

    return (
        <div className={baseStyles.bloodPressureContainer}>
            <Navbar />

            <main className={baseStyles.mainContent}>
                <div className={baseStyles.card}>
                    <div className={baseStyles.cardHeader}>
                        <div className={baseStyles.headerIcon} aria-hidden="true">
                            <Droplet />
                        </div>
                        <h1 className={styles.title}>Cholesterol Test</h1>
                    </div>

                    <div className={baseStyles.patientCard}>
                        <div className={baseStyles.avatar} aria-hidden="true">{initials}</div>
                        <div className={baseStyles.patientText}>
                            <div className={baseStyles.patientName}>{patientName}</div>
                            <div className={baseStyles.patientMetaRow}>
                                <span className={baseStyles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={baseStyles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.sectionTitle}>READINGS</div>

                        <div className={styles.readingsRow}>
                            <div className={baseStyles.readingItem}>
                                <label className={baseStyles.readingLabel}>Total Cholesterol</label>
                                <div className={baseStyles.inputGroup}>
                                    <input
                                        type="number"
                                        value={totalCholesterol}
                                        onChange={(e) => setTotalCholesterol(e.target.value)}
                                        className={baseStyles.readingInput}
                                        placeholder="5.5"
                                    />
                                    <span className={baseStyles.unit}>mmol/L</span>
                                </div>
                            </div>

                            <div className={`${baseStyles.readingItem} ${styles.toggleItem}`}>
                                <div className={styles.toggleRow}>
                                    <label className={baseStyles.readingLabel}>Fasting Status</label>
                                    <button
                                        type="button"
                                        className={`${baseStyles.toggleButton} ${fastingStatus ? baseStyles.active : ''}`}
                                        onClick={() => setFastingStatus(!fastingStatus)}
                                        aria-pressed={fastingStatus}
                                    >
                                        <div className={baseStyles.toggleSlider}></div>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className={baseStyles.toggleSection}>
                            <label className={baseStyles.toggleLabel}>Family History of High Cholesterol</label>
                            <button
                                type="button"
                                className={`${baseStyles.toggleButton} ${familyHistory ? baseStyles.active : ''}`}
                                onClick={() => setFamilyHistory(!familyHistory)}
                                aria-pressed={familyHistory}
                            >
                                <div className={baseStyles.toggleSlider}></div>
                            </button>
                        </div>
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={baseStyles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={baseStyles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={baseStyles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default CholesterolTest;